import { render, staticRenderFns } from "./SubcustTable.vue?vue&type=template&id=1f8a84bb&scoped=true&"
import script from "./SubcustTable.vue?vue&type=script&lang=js&"
export * from "./SubcustTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8a84bb",
  null
  
)

export default component.exports